import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Main from "./frame/Main";
import Login from "./work/Login";
import Mo0101 from "./work/mo/Mo0101";

function App() {
   return (
      <BrowserRouter>
         <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/Main" element={<Main />} /> 
            <Route path="/android" element={<Mo0101 />} /> 
         </Routes>
         
      </BrowserRouter>
   );
}

export default App;
